import SmallRedButton from '@components/common/button/SmallRedButton';
import { FileInfo } from '@data/course/courseData';
import { useThresholds } from '@util/customhooks/useThresholds';
import { truncateText } from '@util/truncateText';
import React from 'react';

interface FileDisplayProps {
  file: FileInfo;
  onRemove?: () => void;
  removable?: boolean;
}

const FileDisplay = ({ file, onRemove, removable }: FileDisplayProps) => {
  const { isAtLeastXL } = useThresholds();

  let filenameMaxLen = 10;

  if (isAtLeastXL) {
    filenameMaxLen += 10;
  }

  if (!removable) {
    filenameMaxLen += 10;
  }

  const filename = truncateText(file.filename, filenameMaxLen);

  return (
    <div className='bg-white px-2 py-4 w-5/6 m-2'>
      <div className='flex flex-row justify-evenly'>
        <p className='flex-1'>{filename}</p>
        {removable ? (
          <SmallRedButton className='w-32' text='DELETE' onClick={onRemove}></SmallRedButton>
        ) : null}
      </div>
    </div>
  );
};

export default FileDisplay;
